import { render, staticRenderFns } from "./Zoho.vue?vue&type=template&id=5b3f5974&scoped=true"
import script from "./Zoho.vue?vue&type=script&lang=js"
export * from "./Zoho.vue?vue&type=script&lang=js"
import style0 from "./Zoho.vue?vue&type=style&index=0&id=5b3f5974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3f5974",
  null
  
)

export default component.exports